/* Tayga 2027 — ficha de producto: Pieza/Par, envío por CP, barra de envío gratis, Arma tu set, barra fija. */
(function () {
  'use strict';
  function money(c) { return '$' + Math.round(c / 100).toLocaleString('es-MX'); }
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  // Peso: la variante trae "10 lb. (4.5 kg.)"; en el botón solo se muestra la unidad principal ("10 lb").
  function oneUnit(s) { return s.replace(/\s*\([^)]*\)[^/]*/g, '').replace(/\.(?=\s|$)/g, '').replace(/\s+/g, ' ').trim(); }
  qsa('.variant-input-wrap[data-handle*="peso"] .variant__button-label').forEach(function (l) {
    var t = oneUnit(l.textContent);
    if (t && t !== l.textContent.trim()) { l.setAttribute('title', l.textContent.trim()); l.textContent = t; }
  });

  var bb = qs('[data-tg-bb]');
  var form = qs('.product-single__form') || qs('form[action*="/cart/add"]');
  var variants = [];
  try { variants = JSON.parse(qs('[data-tg-variants]').textContent); } catch (e) {}
  var FREE = bb ? parseInt(bb.getAttribute('data-free'), 10) : 499900;
  var MSIMIN = bb ? parseInt(bb.getAttribute('data-msimin'), 10) : 150000;
  var cartTotal = 0;

  function currentVariant() {
    var inp = form && form.querySelector('[name="id"]');
    var id = inp ? parseInt(inp.value, 10) : null;
    for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
    return variants[0] || null;
  }
  function qtyInput() {
    if (!form) return null;
    var fid = form.getAttribute('id');
    return form.querySelector('[name="quantity"]') || (fid && document.querySelector('[name="quantity"][form="' + fid + '"]')) || document.querySelector('.product-single__meta .js-qty__num') || document.querySelector('.js-qty__num');
  }
  function qty() { var q = qtyInput(); return q ? Math.max(1, parseInt(q.value, 10) || 1) : 1; }
  function setQty(n) {
    var q = qtyInput(); if (!q) return;
    q.value = n; q.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // ---------- Pieza / Par ----------
  var mode = 2;
  if (bb && bb.getAttribute('data-piece') === 'true') {
    qsa('[data-tg-mode]', bb).forEach(function (b) {
      b.addEventListener('click', function () {
        mode = parseInt(b.getAttribute('data-tg-mode'), 10);
        qsa('[data-tg-mode]', bb).forEach(function (x) { x.classList.toggle('is-on', x === b); });
        var q = qty();
        if (mode === 2 && q % 2 === 1) setQty(q + 1);
        if (mode === 1 && q === 2) setQty(1);
        render();
      });
    });
    if (qty() === 1) setQty(2);
  } else { mode = 1; }

  // ---------- Envío gratis ----------
  function render() {
    if (!bb) return;
    var v = currentVariant(); if (!v) return;
    var q = qty(), line = v.price * q;
    var par = qs('[data-tg-par]', bb);
    if (par) par.textContent = money(v.price * 2) + ' el par · ' + money(v.price) + ' por pieza';
    var fs = qs('[data-tg-fs]', bb), bar = qs('[data-tg-fsbar]', bb);
    var tot = cartTotal + line, falta = Math.max(0, FREE - tot);
    if (fs) fs.innerHTML = falta ? 'Con esto en tu carrito te faltan <b>' + money(falta) + '</b> para envío GRATIS' : '🎉 <b>Con esto tu pedido tiene envío GRATIS</b>';
    if (bar) bar.style.width = Math.min(100, tot / FREE * 100) + '%';
    var st = qs('[data-tg-sticky-sub]');
    if (st) st.textContent = (v.title !== 'Default Title' ? oneUnit(v.title) + ' · ' : '') + money(line);
    var sb = qs('[data-tg-sticky-btn]');
    if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? 'Agregar al carrito' : 'Agotado'; }
  }
  fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
    .then(function (c) { cartTotal = c.total_price || 0; render(); }).catch(function () { render(); });
  if (form) {
    form.addEventListener('change', function () { setTimeout(render, 30); });
    form.addEventListener('click', function () { setTimeout(render, 60); });
  }
  document.addEventListener('variant:change', function () { setTimeout(render, 30); });
  var lastId = null;
  setInterval(function () { var v = currentVariant(); var id = v && v.id + ':' + qty(); if (id !== lastId) { lastId = id; render(); } }, 500);

  // ---------- Entrega por CP ----------
  var cp = bb && qs('[data-tg-cp]', bb);
  if (cp) {
    var eta = qs('[data-tg-eta]', bb);
    var zLocal = bb.getAttribute('data-eta-local'), zRest = bb.getAttribute('data-eta-rest');
    function upd() {
      var c = cp.value.replace(/\D/g, '');
      if (c.length < 5) { eta.textContent = 'Escribe tu código postal'; return; }
      try { localStorage.setItem('tg_cp', c); } catch (e) {}
      var local = /^(0\d|1[0-6]|5[0-7]|4[4-5])/.test(c);
      eta.innerHTML = '<b>' + (local ? zLocal : zRest) + '</b> (estimado)';
    }
    try { var saved = localStorage.getItem('tg_cp'); if (saved) cp.value = saved; } catch (e) {}
    cp.addEventListener('input', upd); upd();
  }

  // ---------- Arma tu set ----------
  var set = qs('[data-tg-set]');
  if (set) {
    var pid = set.getAttribute('data-pid');
    var row = qs('[data-tg-set-row]', set);
    var items = [];
    function renderSet() {
      var v = currentVariant();
      var base = v ? v.price * qty() : 0;
      var t = base;
      items.forEach(function (it) { if (it.on) t += it.price; });
      qs('[data-tg-set-total]', set).textContent = money(t);
      qs('[data-tg-set-note]', set).textContent = (t >= FREE ? '✓ Incluye envío GRATIS' : '');
    }
    function card(it, i) {
      return '<span class="tg-set__plus">+</span><div class="tg-set__it' + (it.on ? ' is-on' : '') + '" data-i="' + i + '">' +
        '<input type="checkbox" aria-label="Agregar ' + it.title.replace(/"/g, '') + '"' + (it.on ? ' checked' : '') + '>' +
        (it.img ? '<img src="' + it.img + '" alt="" loading="lazy">' : '') +
        '<b>' + money(it.price) + '</b><span>' + it.title + '</span><a href="' + it.url + '">Ver producto</a></div>';
    }
    function draw() {
      var html = items.map(card).join('');
      row.insertAdjacentHTML('beforeend', html);
      qsa('.tg-set__it[data-i]', row).forEach(function (el) {
        el.addEventListener('click', function (e) {
          if (e.target.tagName === 'A') return;
          var it = items[+el.getAttribute('data-i')]; it.on = !it.on;
          el.classList.toggle('is-on', it.on); el.querySelector('input').checked = it.on; renderSet();
        });
      });
      renderSet();
    }
    function load(intent) {
      return fetch('/recommendations/products.json?product_id=' + pid + '&limit=5&intent=' + intent)
        .then(function (r) { return r.json(); }).then(function (d) { return (d.products || []).filter(function (p) { return p.available; }); });
    }
    var cols = (set.getAttribute('data-cols') || '').split(',').filter(Boolean);
    var handle = set.getAttribute('data-handle');
    function loadCols() {
      return Promise.all(cols.map(function (h) {
        return fetch('/collections/' + h + '/products.json?limit=12').then(function (r) { return r.json(); })
          .then(function (d) {
            return (d.products || []).filter(function (p) { return p.handle !== handle && p.variants.some(function (v) { return v.available; }); })
              .map(function (p) { return { title: p.title, url: '/products/' + p.handle, featured_image: p.images[0] ? p.images[0].src : '', variants: p.variants.map(function (v) { return { id: v.id, available: v.available, price: Math.round(parseFloat(v.price) * 100) }; }) }; });
          }).catch(function () { return []; });
      })).then(function (lists) {
        var out = [], seen = {};
        for (var k = 0; k < 2; k++) lists.forEach(function (l) { var p = l[k]; if (p && !seen[p.url]) { seen[p.url] = 1; out.push(p); } });
        return out;
      });
    }
    (cols.length ? loadCols() : Promise.resolve([])).then(function (list) {
      return list.length ? list : load('complementary').then(function (l) { return l.length ? l : load('related'); });
    }).then(function (list) {
      var cv = currentVariant(), base = cv ? cv.price * qty() : 0, cap = Math.max(base * 3, 200000), pre = 0;
      list.slice(0, 4).forEach(function (p) {
        var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
        var on = pre < 2 && v.price <= cap; if (on) pre++;
        items.push({ id: v.id, price: v.price, title: p.title, url: p.url, img: p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '', on: on });
      });
      if (!items.length) { set.style.display = 'none'; return; }
      draw();
    }).catch(function () { set.style.display = 'none'; });
    setInterval(renderSet, 700);
    qs('[data-tg-set-add]', set).addEventListener('click', function (e) {
      var btn = e.currentTarget, v = currentVariant(); if (!v) return;
      var payload = [{ id: v.id, quantity: qty() }];
      items.forEach(function (it) { if (it.on) payload.push({ id: it.id, quantity: 1 }); });
      btn.disabled = true; btn.textContent = 'Agregando…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: payload }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { btn.disabled = false; btn.textContent = 'No se pudo agregar, intenta de nuevo'; });
    });
  }

  // ---------- Barra fija ----------
  var sticky = qs('[data-tg-sticky]');
  if (sticky && form && 'IntersectionObserver' in window) {
    var addBtn = form.querySelector('[name="add"]') || form.querySelector('button[type="submit"]');
    new IntersectionObserver(function (en) { sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(form);
    var sb = qs('[data-tg-sticky-btn]', sticky);
    if (sb && addBtn) sb.addEventListener('click', function () { addBtn.click(); });
  }
})();
